import { lazy } from 'react';

const Home = lazy(() => import('../views/home/Home'));
const Knowledge = lazy(() => import('../views/knowledge/Knowledge'));
const ArticleDetail = lazy(() => import('../views/knowledge/ArticleDetail'));
const Strategy = lazy(() => import('../views/strategy/Strategy'));
const MyOrder = lazy(() => import('../views/myOrder/MyOrder'));
const Feedback = lazy(() => import('../views/feedback/Feedback'));
const ProductList = lazy(() => import('../views/product/ProductList'));
const ProductDetail = lazy(() => import('../views/product/ProductDetail'));
const ProductCompute = lazy(() => import('../views/product/ProductCompute'));
const ProductBuy = lazy(() => import('../views/product/ProductBuy'));
const ProductEnsure = lazy(() => import('../views/product/ProductEnsure'));
const ProductHealthInform = lazy(() => import('../views/product/ProductHealthInform'));
const ProductShare = lazy(() => import('../views/product/ProductShare'));
const ProductTerms = lazy(() => import('../views/product/ProductTerms'));
const ProductDisclaimer = lazy(() => import('../views/product/ProductDisclaimer'));
const HealthExamFail = lazy(() => import('../views/product/HealthExamFail'));
const FamilyList = lazy(() => import('../views/family/FamilyList'));
const FamilyEdit = lazy(() => import('../views/family/FamilyEdit'));
const CustomerService = lazy(() => import('../views/customerService/CustomerService'));
const PayResult = lazy(() => import('../views/payResult/PayResult'));
const InsuranceGuide = lazy(() => import('../views/insuranceGuide/InsuranceGuide'));

const Login = lazy(() => import('../views/login/Login'));
const BindPhone = lazy(() => import('../views/login/BindPhone'));
const WeChatLogin = lazy(() => import('../views/component/WeChatLogin'));

const exportComment: any = () => {
  const component = [
    {
      path: '/',
      component: Home,
    },
    {
      path: '/home',
      component: Home,
    },
    {
      path: '/home/:recommendClass',
      component: Home,
    },
    {
      path: '/knowledge',
      component: Knowledge,
    },
    {
      path: '/knowledge/articleDetail/:articleId',
      component: ArticleDetail,
    },
    {
      path: '/strategy',
      component: Strategy,
    },
    {
      path: '/myOrder',
      component: MyOrder,
    },
    {
      path: '/myOrder/:orderType',
      component: MyOrder,
    },
    {
      path: '/feedback',
      component: Feedback,
    },
    {
      path: '/product/productList',
      component: ProductList,
    },
    {
      path: '/product/productDetail/:goodsId',
      component: ProductDetail,
    },
    {
      path: '/product/productDetail/:goodsId/:invitationCode',
      component: ProductDetail,
    },
    {
      path: '/product/productCompute/:goodsId',
      component: ProductCompute,
    },
    {
      path: '/product/productBuy/:goodsId',
      component: ProductBuy,
    },
    {
      path: '/product/productBuy/:goodsId/:numberCode',
      component: ProductBuy,
    },
    {
      path: '/product/productEnsure/:orderCode',
      component: ProductEnsure,
    },
    {
      path: '/product/productHealthInform/:goodsId',
      component: ProductHealthInform,
    },
    {
      path: '/product/productTerms/:goodsId',
      component: ProductTerms,
    },
    {
      path: '/product/productDisclaimer/:goodsId',
      component: ProductDisclaimer,
    },
    {
      path: '/product/productHealthInform/:goodsId/:numberCode/:conclusion',
      component: ProductHealthInform,
    },
    {
      path: '/product/productShare/:goodsId/:linkType',
      component: ProductShare,
    },
    {
      path: '/product/healthExamFail',
      component: HealthExamFail,
    },
    {
      path: '/family/familyList',
      component: FamilyList,
    },
    {
      path: '/family/familyEdit',
      component: FamilyEdit,
    },
    {
      path: '/family/familyEdit/:id',
      component: FamilyEdit,
    },
    {
      path: '/customerService',
      component: CustomerService,
    },
    {
      path: '/payResult/:orderCode',
      component: PayResult,
    },
    {
      path: '/insuranceGuide',
      component: InsuranceGuide,
    },
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/bindPhone',
      component: BindPhone,
    },
    {
      path: '/weChatLogin',
      component: WeChatLogin,
    }
  ];
  return component;
}

export default exportComment();
